import type { ReactNode } from 'react'

import { useLocalization } from '@/shared/i18n'
import { Button, Stack, Stage, Text } from '@/shared/ui'
import mascot from '@/shared/ui/brand/mascot.webp'

export function Welcome({ rail, onNext }: { rail: ReactNode; onNext: () => void }) {
  const { t } = useLocalization()

  return (
    <Stage
      rail={rail}
      top
      flush
      footer={
        <Button full onClick={onNext}>
          {t('onboarding.welcome.start')}
        </Button>
      }
    >
      <Stack gap="sm" className="welcome__head">
        <Text as="h1" role="heading-1">
          {t('onboarding.welcome.title')}
        </Text>
        <Text tone="muted" measure>
          {t('onboarding.welcome.body')}
        </Text>
      </Stack>
      <div className="welcome__art">
        <img className="welcome__mascot" src={mascot} alt="" />
      </div>
    </Stage>
  )
}
